module.exports = __webpack_public_path__ + "static/media/exit2.a40e6730.svg";